import { render, staticRenderFns } from "./ledgerPayExpense.vue?vue&type=template&id=610fb764&scoped=true"
import script from "./ledgerPayExpense.vue?vue&type=script&lang=js"
export * from "./ledgerPayExpense.vue?vue&type=script&lang=js"
import style0 from "./ledgerPayExpense.vue?vue&type=style&index=0&id=610fb764&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "610fb764",
  null
  
)

export default component.exports